import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  loadUserSession,
  loadSiteWideUserSession
} from './actions/shared.actions';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  constructor(private readonly store: Store) {}

  init(useSiteWide = false) {
    if (useSiteWide) {
      this.store.dispatch(loadSiteWideUserSession());
    } else {
      this.store.dispatch(loadUserSession());
    }
  }
}
